export default __webpack_public_path__ + "static/media/lieferheld_s3.f5764dbc.png";